import * as angular from 'angular';
import * as _ from "lodash";
import {apsEnums} from "../../shared/dto/aps.enums";
import DefectCausesServiceName, {DefectCausesService} from "../../services/defectCauses/defectCause.service";
import ToolChangeServiceName, {ToolChangeService} from "../../services/toolChange/toolChange.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import template from './addDefectCause.tpl.html';

let requires = [DefectCausesServiceName, ToolChangeServiceName, UIUtilityServiceName, NewGuidServiceName,
  NotifyServiceName, LoaderServiceName];

export interface AddDefectCauseData {
  defectTypeId: string;
}

export default angular.module('aps.controller.addDefectCause', requires)
  .controller('AddDefectCauseCtrl', addDefectCauseCtrl)
  .name;

export function openAddDefectCause(data: AddDefectCauseData,
                                   $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddDefectCauseCtrl as addDefectCauseCtrl',
    resolve: {
      data: () => data
    }
  }).result;
}

function addDefectCauseCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: AddDefectCauseData,
  loaderService: LoaderService,
  notifyService: NotifyService,
  newGuidService: NewGuidService,
  defectCausesService: DefectCausesService,
  toolChangeService: ToolChangeService,
  uiUtilityService: UIUtilityService
) {
  'use strict';

  var vm = this;

  vm.defectCause = {
    defectTypeId: data.defectTypeId,
    priority: 0,
    probability: 0.00,
    enabled: true
  };

  vm.reasons = uiUtilityService.getListOptionsFromEnum(apsEnums.ToolChangeReason, 0);

  toolChangeService.getToolsAndTypes().then((tools) => {
    vm.tools = tools;
  });

  newGuidService.getNewGuid('defectCause')
    .then(function(data) {
      vm.defectCause.id = data;
    });

  defectCausesService.getCourseOfActions().then(function(courseOfActions){
    vm.courseOfActions = courseOfActions;
  });

  vm.submitDefectCause = function() {
    if (!vm.defectCause.courseOfActionId) {
      vm.defectCause.toolId = null;
      vm.reason = null;
    }

    if (((vm.defectCause || '') !== '') && ((vm.defectCause.courseOfActionId || '') !== '')) {
      var defectCauseUpdated = _.find(vm.courseOfActions,
        function (item) {
          return (<any>item).id === vm.defectCause.courseOfActionId;
        });
      if ((defectCauseUpdated || '') !== '') {
        vm.defectCause.courseOfActionName = (<any>defectCauseUpdated).name;
        vm.defectCause.courseOfActionToolChange = (<any>defectCauseUpdated).toolChange;
      }
    }

    var promise = defectCausesService.addDefectCause(vm.defectCause)
      .then(function () {
        $modalInstance.close(vm.defectCause);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.cancel = function() {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectTypeAdmin/addDefectCause.controller.ts